<template>
    <div>
        <app-card>
            <div class="d-flex justify-space-between align-center mb-4">
                <div>
                    <h3 class="mb-2" style="font-size: 24px; font-weight: bold;">BẢNG THEO DÕI TRẢ MẠNG</h3>
                    <p class="fs-14 grey--text">Theo dõi các phòng đã trả mạng Internet</p>
                </div>
                <div class="text-right">
                    <v-btn color="primary" @click="exportToExcel" :loading="loading.export" dark>
                        <v-icon left>file_download</v-icon>
                        Xuất Excel
                    </v-btn>
                </div>
            </div>

            <v-data-table :loading="loading.table" :headers="headers" :items="filteredItems"
                :rows-per-page-items="[10, 25, 50, 100]" class="elevation-1 compact-table" :search="search" disable-initial-sort>

                <template #headers="props">
                    <tr>
                        <th :class="['fw-bold', `text-xs-${header.align}`]" :style="{ width: header.width }"
                            v-for="header in props.headers" :key="header.text">
                            {{ header.text }}
                        </th>
                    </tr>
                </template>
                <template #items="props">
                    <tr>
                        <td class="text-center text-no-wrap">{{ props.item.building }}</td>
                        <td class="text-center text-no-wrap">{{ props.item.room_id }}</td>
                        <td class="text-center text-no-wrap">
                            <span :class="['v-badge', internet_status[props.item.status].badge]">
                                {{ internet_status[props.item.status].text }}
                            </span>
                        </td>
                        <td class="text-center text-no-wrap">{{ getReceiptId(props.item) }}</td>
                        <td class="text-center text-no-wrap">{{ formatDate(props.item.date_schedule_out) }}</td>
                        <td class="text-center text-no-wrap">
                            <v-edit-dialog :return-value.sync="props.item.expected_implementation_date_display"
                                @save="saveExpectedDate(props.item)" large persistent scrollable>
                                <template v-slot:default>
                                    <div>{{ props.item.expected_implementation_date_display }}</div>
                                </template>
                                <template v-slot:input>
                                    <v-date-picker v-model="props.item.expected_implementation_date" format="DD/MM/YYYY"
                                        @input="props.item.expected_implementation_date_display = formatDate(props.item.expected_implementation_date)"></v-date-picker>
                                </template>
                            </v-edit-dialog>
                        </td>
                        <td class="text-center text-no-wrap">
                            {{ props.item.user || '' }}
                        </td>
                        <td class="text-center text-no-wrap">{{ formatCurrency(props.item.package_price) }}</td>
                        <td class="text-center text-no-wrap">{{ formatDate(props.item.renewal_end_date) }}</td>
                        <td class="text-center text-no-wrap">
                            <span
                                :class="['v-badge', props.item.wifi_type ? wifi_type_badges[props.item.wifi_type].badge : '']">
                                {{ wifi_type_badges[props.item.wifi_type] ? wifi_type_badges[props.item.wifi_type].text
                                : props.item.wifi_type
                                }}
                            </span>
                        </td>
                        <td class="text-center text-no-wrap">{{ getPairWifiList(props.item) }}</td>
                        <td style="cursor: pointer; max-width: 200px; word-wrap: break-word; word-break: break-word; white-space: normal;" class="text-center">
                            <v-edit-dialog
                                large
                                lazy
                                @save="saveReturnPlan(props.item)"
                                @open="props.item.new_return_plan = props.item.return_plan"
                            >
                                <div style="max-width: 200px; white-space: normal; word-wrap: break-word; word-break: break-word;">
                                    {{ props.item.return_plan || '' }}
                                </div>
                                <template v-slot:input>
                                    <v-text-field
                                        v-model="props.item.new_return_plan"
                                        label="Phương án"
                                        single-line
                                    ></v-text-field>
                                </template>
                            </v-edit-dialog>
                        </td>
                    </tr>
                </template>
                <template #no-data>
                    Chưa có thông tin
                </template>
            </v-data-table>
        </app-card>
    </div>
</template>

<script>
import api from "Api";
import moment from 'moment';
import ExportCsvButton from "Components/ExportExcel/ExportCsvButton";
import { buildParamQuery } from "Helpers";

export default {
    name: "InternetReturnTracking",
    components: {
        ExportCsvButton
    },
    data() {
        return {
            loading: {
                table: false,
                export: false
            },
            search: '',
            items: [],
            allInternetItems: [],
            headers: [
                { text: 'Tòa nhà', value: 'building', align: 'center', sortable: true, width: '70px' },
                { text: 'Phòng', value: 'room_id', align: 'center', sortable: true, width: '70px' },
                { text: 'Tình trạng', value: 'status', align: 'center', sortable: true, width: '80px' },
                { text: 'Số phiếu', value: 'receipt_id', align: 'center', sortable: true, width: '80px' },
                { text: 'Ngày trả phòng', value: 'date_schedule_out', align: 'center', sortable: true, width: '110px' },
                { text: 'Ngày dự kiến thực hiện', value: 'expected_implementation_date', align: 'center', sortable: true, width: '120px' },
                { text: 'User', value: 'user', align: 'center', sortable: true, width: '200px' },
                { text: 'Giá gói cước', value: 'package_price', align: 'center', sortable: true, width: '80px' },
                { text: 'Ngày kết thúc gia hạn', value: 'renewal_end_date', align: 'center', sortable: true, width: '120px' },
                { text: 'Wifi', value: 'wifi_type', align: 'center', sortable: true, width: '80px' },
                { text: 'Wifi bắt cặp', value: 'pair_wifi_list', align: 'center', sortable: true, width: '120px' },
                { text: 'Phương án', value: 'return_plan', align: 'center', sortable: true, width: '200px' },
            ],
            exportHeaders: [
                'Tòa nhà',
                'Phòng',
                'Tình trạng',
                'Số phiếu',
                'Ngày trả phòng',
                'Ngày dự kiến thực hiện',
                'User',
                'Giá gói cước',
                'Ngày kết thúc gia hạn',
                'Wifi',
                'Wifi bắt cặp',
                'Phương án',
                'Ghi chú'
            ],
            wifi_type_badges: {
                'main': { text: 'Wifi chính', badge: 'success' },
                'auxiliary': { text: 'Wifi phụ', badge: 'info' },
                'private': { text: 'Wifi riêng', badge: 'warning' }
            },
            internet_status: {
                0: {
                    text: "Mạng trống",
                    badge: "error"
                },
                1: {
                    text: "Đang hoạt động",
                    badge: "primary"
                },
                2: {
                    text: "Trả phòng",
                    badge: "warning"
                },
            },
        };
    },
    computed: {
        filteredItems() {
            return this.items.filter(item => {
                if (!this.search) return true;
                const searchLower = this.search.toLowerCase();
                const pairWifiList = this.getPairWifiList(item);
                return (
                    (item.building && item.building.toLowerCase().includes(searchLower)) ||
                    (item.room_id && item.room_id.toLowerCase().includes(searchLower)) ||
                    (item.user && item.user.toLowerCase().includes(searchLower)) ||
                    (item.receipt_id && item.receipt_id.toLowerCase().includes(searchLower)) ||
                    (pairWifiList && pairWifiList.toLowerCase().includes(searchLower))
                );
            });
        },
        dataForExport() {
            return this.filteredItems.map(item => ({
                'Tòa nhà': item.building || '',
                'Phòng': item.room_id || '',
                'Tình trạng': this.internet_status[item.status].text,
                'Số phiếu': this.getReceiptId(item),
                'Ngày trả phòng': this.formatDate(item.date_schedule_out),
                'Ngày dự kiến thực hiện': this.formatDate(item.expected_implementation_date),
                'User': item.user || '',
                'Giá gói cước': item.package_price,
                'Ngày kết thúc gia hạn': this.formatDate(item.renewal_end_date),
                'Wifi': this.wifi_type_badges[item.wifi_type] ? this.wifi_type_badges[item.wifi_type].text : (item.wifi_type || ''),
                'Wifi bắt cặp': this.getPairWifiList(item),
                'Phương án': item.return_plan || 'Chưa có phương án',
            }));
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        async loadData() {
            try {
                this.loading.table = true;
                const response = await api.getListInternet(
                    buildParamQuery({ getValidAndNotValid: true })
                );

                if (response.status === 200) {
                    this.allInternetItems = response.data.internet || [];
                    const trackingKey = (item) => {
                        if (!item.room_id) return null;
                        return String(item.room_id);
                    };
                    const withStatus = this.allInternetItems.map(item => {
                        item.status = this.updateItemStatus(item);
                        return item;
                    });

                    const groupsByRoom = new Map();
                    const noKeyItems = [];
                    for (const item of withStatus) {
                        const key = trackingKey(item);
                        if (key == null) {
                            noKeyItems.push(item);
                            continue;
                        }
                        if (!groupsByRoom.has(key)) groupsByRoom.set(key, []);
                        groupsByRoom.get(key).push(item);
                    }

                    const pickNewest = (arr) => {
                        return arr.reduce((a, b) => {
                            if (a.is_valid !== b.is_valid) return b.is_valid ? b : a;
                            const ta = new Date(a.updatedAt || a.createdAt || 0).getTime();
                            const tb = new Date(b.updatedAt || b.createdAt || 0).getTime();
                            return tb >= ta ? b : a;
                        });
                    };

                    // Gom trước: mỗi phòng 1 dòng đại diện (ưu tiên bản đang valid, rồi mới nhất)
                    const onePerRoom = [];
                    for (const [, group] of groupsByRoom) {
                        onePerRoom.push(pickNewest(group));
                    }
                    onePerRoom.push(...noKeyItems);

                    const merged = onePerRoom.filter(
                        item => item.status === 0 || item.status === 2
                    );

                    this.items = merged.map(item => {
                        item.expected_implementation_date = item.expected_implementation_date || null;
                        item.expected_implementation_date_display = item.expected_implementation_date ? this.formatDate(item.expected_implementation_date) : '';
                        item.menu_expected_implementation_date = false;
                        item.return_plan = item.return_plan || '';
                        item.return_note = item.return_note || '';
                        item.package_price = item.price || 0;

                        return item;
                    }).sort((a, b) => {
                        const dateA = a.date_schedule_out ? new Date(a.date_schedule_out) : (a.createdAt ? new Date(a.createdAt) : new Date(0));
                        const dateB = b.date_schedule_out ? new Date(b.date_schedule_out) : (b.createdAt ? new Date(b.createdAt) : new Date(0));
                        return dateB - dateA;
                    });
                } else {
                    console.error('Error loading data:', response);
                    swal.fire('Lỗi', 'Không thể tải dữ liệu', 'error');
                }
            } catch (error) {
                console.error('Error in loadData:', error);
                swal.fire('Lỗi', 'Có lỗi xảy ra khi tải dữ liệu', 'error');
            } finally {
                this.loading.table = false;
            }
        },

        updateItemStatus: function (item) {
            if (!item.room_state_id) return 0;
            else if (!item.date_schedule_out) return 1;
            return 2;
        },

        getReceiptId: function (item) {
            // Phòng trả phòng: hiển thị mã phiếu trả phòng từ CheckOut
            if (item.date_schedule_out) {
                return item.check_out_receipt_id || '';
            }
            // Phòng tự trả mạng: để trống
            return '';
        },

        async updateField(item, field) {
            try {
                const postData = {
                    internet_id: item._id,
                    [field]: item[field]
                };

                const response = await api.updateReturnTracking(postData);

                if (response.status === 200) {
                    if (field === 'expected_implementation_date' && item[field]) {
                        item.expected_implementation_date_display = this.formatDate(item[field]);
                    }
                } else {
                    console.error('Có lỗi xảy ra khi cập nhật');
                }
            } catch (error) {
                console.error('Error updating field:', error);
            }
        },
        async saveExpectedDate(item) {
            await this.updateField(item, 'expected_implementation_date');
        },
        async saveReturnPlan(item) {
            item.return_plan = item.new_return_plan;
            await this.updateField(item, 'return_plan');
        },
        async saveReturnNote(item) {
            await this.updateField(item, 'return_note');
        },
        formatDate(date) {
            if (!date) return '';
            return moment(date).format('DD/MM/YYYY');
        },
        formatCurrency(amount) {
            if (!amount) return '';
            return new Intl.NumberFormat('vi-VN').format(amount);
        },
        getPairWifiList(item) {
            if (!item.user) return '';
            
            if (item.wifi_type === 'main' || item.wifi_type === 'private') {
                const auxiliaryItems = this.allInternetItems.filter(i => 
                    i.user === item.user && 
                    i.wifi_type === 'auxiliary'
                );
                if (auxiliaryItems.length > 0) {
                    return auxiliaryItems.map(i => i.room_id).filter((v, i, a) => a.indexOf(v) === i).join(', ');
                }
            } else if (item.wifi_type === 'auxiliary') {
                const mainItems = this.allInternetItems.filter(i => 
                    i.user === item.user && 
                    (i.wifi_type === 'main' || i.wifi_type === 'private')
                );
                if (mainItems.length > 0) {
                    return mainItems.map(i => i.room_id).filter((v, i, a) => a.indexOf(v) === i).join(', ');
                }
            }
            
            return '';
        },
        exportToExcel() {
            try {
                this.loading.export = true;

                const data = this.dataForExport;

                const headers = this.exportHeaders;
                const csvContent = [headers.join(',')];

                data.forEach(row => {
                    const values = headers.map(header => {
                        const value = row[header] || '';
                        return `"${value}"`;
                    });
                    csvContent.push(values.join(','));
                });

                const blob = new Blob([csvContent.join('\n')], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', `bao-cao-tra-mang-${new Date().toISOString().substring(0, 10)}.csv`);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                swal.fire('Thành công', 'Đã xuất excel thành công', 'success');
            } catch (error) {
                console.error('Error exporting to excel:', error);
                swal.fire('Lỗi', 'Có lỗi xảy ra khi xuất excel', 'error');
            } finally {
                this.loading.export = false;
            }
        }
    }
};
</script>

<style scoped>
.v-data-table th,
.v-data-table td {
    padding: 6px 3px !important;
    font-size: 11px;
}

.compact-table {
    table-layout: fixed !important;
    width: 100% !important;
    max-width: 100% !important;
}

.compact-table>>>.v-datatable__wrapper {
    overflow-x: hidden !important;
    max-width: 100% !important;
}

.compact-table>>>table {
    table-layout: fixed !important;
    width: 100% !important;
    max-width: 100% !important;
}

</style>